import React from 'react'
import empty from '../../assets/images/OBJECTS.png'

export default function NotFound({ paragraphText }) {
  return (
    <div className=' d-flex justify-content-center align-items-center w-100 h-100'>
  <div className=" d-flex flex-column align-items-center ">
      <img src={empty} alt="" />
      <h4 className=' my-4 w-100 text-center text-muted'>
        {paragraphText}
      </h4>
    </div>
    </div>
  
  );
}
